function heatmapController(DatatableLang, $state, $scope, WS, $window, AppSettings, $translate) {
    'ngInject';
    const vm = this;

    WS.getData('heatmap/github_calendar_heatmap')
      .then(function (response) {
         
             var visites = response.data;
             var resultat = {};

             _.each(visites , (element, index) => {
                if(resultat.hasOwnProperty(element.date)){
                  resultat[element.date].items.push(element.type);
                  resultat[element.date].values.push({
                    type: element.type,
                    nbr: element.nbr
                  });
                }else{
                  resultat[element.date] = {};
                  resultat[element.date].items = [];
                  resultat[element.date].items.push(element.type);
                  resultat[element.date].values = [];
                  resultat[element.date].values.push({
                    type: element.type,
                    nbr: element.nbr
                  });
                  
                }
             })
             vm.data_visites = resultat;
             console.log(vm.data_visites);
              $scope.$apply();


              $(document).ready(function() {
                $('.github_calendar_heatmap').calendar_yearview_blocks({
                    data: vm.data_visites,
                    final_date: new Date().toISOString().slice(0, 10),
                    colors: {
                    'default': '#eeeeee',
                    'bl' : 'orange',
                    'visite': 'blue',
                    'Plan de charge': 'lightgreen',
                    'commande': 'green',
                    'avoir' : 'red' 
                    },
                    month_names: ['jan', 'fev', 'mar', 'avr', 'mai', 'jun', 'jui', 'aot', 'sept', 'okt', 'nov', 'dec'],
                    day_names: ['Lun', 'Mar', 'Mer','Jeu', 'Ven','Sam', 'Dim'],
                    always_show_tooltip: false,
                    //stylize_today: false,
                    //start_monday: true,
                    start_monday: true,
                   tooltip_style: 'custom'
                });
    
    
                
            })
         
      })
      .then(null, function (error) {
          console.log(error);
      });
    // vm.mydata = {
    //               "2021-02-01":  {
    //                 "items": ["banana", "apple"]
    //               },
    //               "2021-04-05": {
    //                 "items": ["apple"]
    //               },
    //               "2021-07-01": {
    //                 "items": ["banana"]
    //               },
    //               "2021-06-03": {
    //                 "items": ["banana", "apple", "orange"]
    //               },
    //               "2021-07-13": {
    //                 "items": ["banana", "apple", "orange"]
    //               }
    //               // more activities here
    //         };

    (function ($) {
        window.$.fn.calendar_yearview_blocks = function (options) {
    
            // Format string
            if (!String.prototype.formatString) {
                String.prototype.formatString = function () {
                    var args = arguments;
                    return this.replace(/{(\d+)}/g, function (match, number) {
                        return typeof args[number] !== 'undefined'
                            ? args[number]
                            : match
                            ;
                    });
                };
            }
    
            // If the number less than 10, add a zero before it
            var prettyNumber = function (number) {
                return number < 10 ? '0' + number.toString() : number = number.toString();
            };
    
            var getDisplayDate = function (date_obj) {
                var pretty_month = prettyNumber(date_obj.getMonth() + 1);
                var pretty_date = prettyNumber(date_obj.getDate());
                return "{0}-{1}-{2}".formatString(date_obj.getFullYear(), pretty_month, pretty_date);
            };
    
            var start = function () {
                console.log(settings);
                var obj_timestamp = JSON.parse(JSON.stringify(settings.data));
    
                var wrap_chart = _this;
    
                var end_date = new Date(settings.final_date);
                end_date.setDate(end_date.getDate() + 1);
                var current_date = new Date();
                var start_date = new Date();
                start_date.setMonth(end_date.getMonth() - 12);
    
                var start_weekday = settings.start_monday === true?1:0;
                for (var i = 0; i < 7; i++) {
                    var day = start_date.getDay();
                    if (day === start_weekday) {
                        break;
                    }
                    else {
                        // Loop until start_weekday
                        start_date.setDate(start_date.getDate() + 1);
                    }
                }
                var loop_html = "";
    
                // One year has 52 weeks
                var step = 13; // Amount of pixels to move
    
                var month_position = [];
                month_position.push({month_index: start_date.getMonth(), x: 0});
                var using_month = start_date.getMonth();
                for (var i = 0; i <= 52; i++) { // For each week, generate a column
                    var g_x = i * step;
                    var item_html = '<g transform="translate(' + g_x.toString() + ',0)">';
    
                    for (var j = 0; j < 7; j++) { // For each weekday, generate a row
    
                        if (start_date > end_date) {
                            // Break the loop when today's date is found
                            break;
                        }
                        var y = j * step;
    
                        var month_in_day = start_date.getMonth();
                        var data_date = getDisplayDate(start_date);
    
                        // Check first day in week
                        if (j === start_weekday && month_in_day !== using_month) {
                            using_month = month_in_day;
                            month_position.push({month_index: using_month, x: g_x});
                        }
    
                        // Put a box around today's date
                        if (settings.stylize_today) {
                            var match_today = current_date.getTime() === start_date.getTime() ? '" style="stroke:black;stroke-width:2;opacity:0.5"' : '';
                        } else {
                            var match_today = "";
                        }
    
                        var items = [];
                        var legend = '', items_str = '';
                        if (obj_timestamp[data_date]) {
                            if (obj_timestamp[data_date].items) {
                                items = obj_timestamp[data_date].items;
                                items_str = items.join(", ")
                                items_str = items_str.replaceAll('&', '&amp;');
                                items_str = items_str.replaceAll('"', '&quot;');
                            }
                            if (obj_timestamp[data_date].legend) {
                                legend = obj_timestamp[data_date].legend;
                                legend = legend.replaceAll('&', '&amp;');
                                legend = legend.replaceAll('"', '&quot;');
                            }
                        }
    
                        var item_name = items[0]?items[0]:false;
                        var color = settings.colors[item_name]?settings.colors[item_name]:settings.colors['default'];
    
                        // Fill a square for the 1st item
                        item_html += '<rect class="day" width="11" height="11" y="' + y + '" fill="' + color + match_today + '" data-items="' + items_str + '" data-legend="' + legend + '" data-date="' + data_date + '"/>';
                        if (items.length === 2) { // Fill a trangle for the 2nd
                            var item_name_1 = items[1]?items[1]:false;
                            var color_1 = settings.colors[item_name_1]?settings.colors[item_name_1]:settings.colors['default'];
                            item_html += '<polygon points="' + 0 + ',' + (y+11) + ' ' + 0 + ',' + y + ' ' + 11 + ',' + y + '" fill="' + color_1 + '" data-items="' + items_str + '" data-legend="' + legend + '" data-date="' + data_date + '"/>';
                        } else if (items.length === 3) { // Fill 2 rectangles for 2nd and 3rd
                            var item_name_1 = items[1]?items[1]:false;
                            var color_1 = settings.colors[item_name_1]?settings.colors[item_name_1]:settings.colors['default'];
                            var item_name_2 = items[2]?items[2]:false;
                            var color_2 = settings.colors[item_name_2]?settings.colors[item_name_2]:settings.colors['default'];
                            item_html += '<polygon points="' + 0 + ',' + (y+8) + ' ' + 0 + ',' + y + ' ' + 11 + ',' + y + ' ' + 11 + ',' + (y+8) + '" fill="' + color_1 + '" data-items="' + items_str + '" data-legend="' + legend + '" data-date="' + data_date + '"/>';
                            item_html += '<polygon points="' + 0 + ',' + (y+4) + ' ' + 0 + ',' + y + ' ' + 11 + ',' + y + ' ' + 11 + ',' + (y+4) + '" fill="' + color_2 + '" data-items="' + items_str + '" data-legend="' + legend + '" data-date="' + data_date + '"/>';
                        } else if (items.length === 4) { // Fill 3 cubes for 2nd, 3rd and 4th
                            var item_name_1 = items[1]?items[1]:false;
                            var color_1 = settings.colors[item_name_1]?settings.colors[item_name_1]:settings.colors['default'];
                            var item_name_2 = items[2]?items[2]:false;
                            var color_2 = settings.colors[item_name_2]?settings.colors[item_name_2]:settings.colors['default'];
                            var item_name_3 = items[3]?items[3]:false;
                            var color_3 = settings.colors[item_name_3]?settings.colors[item_name_3]:settings.colors['default'];
                            item_html += '<polygon points="' + 0 + ',' + (y+11) + ' ' + 0 + ',' + (y+6) + ' ' + 6 + ',' + (y+6) + ' ' + 6 + ',' + (y+11) + '" fill="' + color_1 + '" data-items="' + items_str + '" data-legend="' + legend + '" data-date="' + data_date + '"/>';
                            item_html += '<polygon points="' + 0 + ',' + (y+6) + ' ' + 0 + ',' + y + ' ' + 6 + ',' + y + ' ' + 6 + ',' + (y+6) + '" fill="' + color_2 + '" data-items="' + items_str + '" data-legend="' + legend + '" data-date="' + data_date + '"/>';
                            item_html += '<polygon points="' + 6 + ',' + (y+6) + ' ' + 6 + ',' + y + ' ' + 11 + ',' + y + ' ' + 11 + ',' + (y+6) + '" fill="' + color_3 + '" data-items="' + items_str + '" data-legend="' + legend + '" data-date="' + data_date + '"/>';
                        }
    
                        // Move on to the next day
                        start_date.setDate(start_date.getDate() + 1);
    
                    }
    
                    item_html += "</g>";
    
                    loop_html += item_html;
    
                }
    
                // Trick
                if (month_position[1].x - month_position[0].x < 40) {
                    // Fix ugly graph by removing the first item
                    month_position.shift(0);
                }
    
                // Add labels for Months
                for (var i = 0; i < month_position.length; i++) {
                    var item = month_position[i];
                    var month_name = settings.month_names[item.month_index];
                    loop_html += '<text x="' + item.x + '" y="-5" class="month">' + month_name + '</text>';
                }
    
                // Add labels for Weekdays
                if (settings.start_monday === true) {
                    loop_html += '<text  class="wday" dx="-25" dy="11">{0}</text>'.formatString(settings.day_names[0]) +
                        '<text  class="wday" dx="-25" dy="23">{0}</text>'.formatString(settings.day_names[1]) +
                        '<text  class="wday" dx="-25" dy="35">{0}</text>'.formatString(settings.day_names[2]) +
                        '<text  class="wday" dx="-25" dy="49">{0}</text>'.formatString(settings.day_names[3]) +
                        '<text  class="wday" dx="-25" dy="61">{0}</text>'.formatString(settings.day_names[4]) +
                        '<text  class="wday" dx="-25" dy="75">{0}</text>'.formatString(settings.day_names[5]) +
                        '<text  class="wday" dx="-25" dy="87">{0}</text>'.formatString(settings.day_names[6]);
                } else {
                    loop_html += '<text text-anchor="middle" class="wday" dx="-10" dy="22">{0}</text>'.formatString(settings.day_names[0]) +
                        '<text text-anchor="middle" class="wday" dx="-10" dy="48">{0}</text>'.formatString(settings.day_names[1]) +
                        '<text text-anchor="middle" class="wday" dx="-10" dy="74">{0}</text>'.formatString(settings.day_names[2]);
                }
    
                // Fixed size with width= 721 and height = 110
                var wire_html =
                    '<svg width="721" height="110">' +
                    '<g transform="translate(25, 20)">' +
                    loop_html +
                    '</g>' + '"Your browser does not support inline SVG."' +
                    '</svg>';
    
                wrap_chart.html(wire_html);
    
                _this.find('rect, polygon').on("mouseenter", mouseEnter);
                _this.find('rect, polygon').on("mouseleave", mouseLeave);
                _this.find('rect, polygon').on("click", mouseClick);
                //appendTooltip();
    
            };
    
            var mouseLeave = function (evt) {
                $('.svg-tip').hide();
            };
    
            var mouseClick = function (evt) {
                var items = $(evt.target).attr('data-items');
                var date = $(evt.target).attr('data-date');
                $("#moreinfo").text("Date: {0} : {1}".formatString(date, items))
                console.log("Date: {0} : {1}".formatString(date, items))

                $(`.value_bl`).empty();
                $(`.value_avoir`).empty();
                $(`.value_commande`).empty();
                $(`.value_plan_de_charge`).empty();
                $(`.value_visites`).empty();
                if(vm.data_visites.hasOwnProperty(date)){
                    if(vm.data_visites[date].values){
                        _.each(vm.data_visites[date].values, (element, index) => {
                            var type = element.type =='Plan de charge' ? element.type.replace(/\s+/g, '_').toLowerCase() : element.type;
                            $(`.value_${type}`).text(element.nbr);
                        });
                    }
                }
                
                
            };
    
            // Handle mouseEnter event when entering into rect element
            var mouseEnter = function (evt) {
    
                var target_offset = $(evt.target).offset();
                var items = $(evt.target).attr('data-items');
                var legend = $(evt.target).attr('data-legend');
                var date = $(evt.target).attr('data-date');
    
                var text = settings.tooltip_style === 'default' ? "{0}: <br />{1}".formatString(date, legend ? legend : items) : (legend ? legend : items);
    
                // Depending on settings, only show a tooltip when there's something to be shown
                if (items.length >= 1 ||  settings.always_show_tooltip === true) {
                    var svg_tip = $('.svg-tip').show();
                    svg_tip.html(text);
                    var svg_width = Math.round(svg_tip.width() / 2 + 5);
                    var svg_height = svg_tip.height() * 2 + 10;
    
                    svg_tip.css({top: target_offset.top - svg_height - 5});
                    svg_tip.css({left: target_offset.left - svg_width});
                }

                $("#moreinfo").text("Date: {0} : {1}".formatString(date, items))
                //console.log("Date: {0} : {1}".formatString(date, items))

                // console.log(date, items, vm.data_visites);
                // vm.crrent_date_selected = date;
                $(`.value_bl`).empty();
                $(`.value_avoir`).empty();
                $(`.value_commande`).empty();
                $(`.value_plan_de_charge`).empty();
                $(`.value_visites`).empty();

                if(vm.data_visites.hasOwnProperty(date)){
                    if(vm.data_visites[date].values){
                        _.each(vm.data_visites[date].values, (element, index) => {
                            var type = element.type =='Plan de charge' ? element.type.replace(/\s+/g, '_').toLowerCase() : element.type;
                            $(`.value_${type}`).text(element.nbr);
                        });
                    }
                }
            };
    
            // Append tooltip to display when the mouse enters the rect element
            // Default is display:none
            // var appendTooltip = function () {
            //     if ($('.svg-tip').length === 0) {
            //         $('body').append('<div class="svg-tip svg-tip-one-line" style="display:none" ></div>');
            //     }
            // };
    
            // Default settings which can be overridden by the user
            var settings = $.extend({
                colors: {
                        'default': '#eeeeee'
                },
                month_names: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                day_names: ['M', 'W', 'F', 'S'],
                start_monday: true,
                always_show_tooltip: false,
                stylize_today: false,
                final_date: new Date().toISOString().slice(0, 10),
                tooltip_style: 'default', // or 'custom'
                data: []
            }, options);
    
            var _this = $(this);
    
            start();
    
        };
    }(jQuery));   

/*****************************************************************2222***************************************************************** */
/*
 *  jquery-calendar-heatmap - v1.1.0
 *  A simple Calendar Heatmap for jQuery.
 *  https://github.com/SeBassTian23/CalendarHeatmap
 *
 *  Made by Sebastian Kuhlgert
 *  Under MIT License
 */
( function( $ ) {

    "use strict";

        // Default Options
        var pluginName = "CalendarHeatmap",
            defaults = {
                title: null,
                months: 12,
                weekStartDay: 1,
                lastMonth: moment().month() + 1,
                lastYear: moment().year(),
                coloring: null,
                labels: {
                    days: false,
                    months: true,
                    custom: {
                        weekDayLabels: null,
                        monthLabels: null
                    }
                },
                tiles: {
                    shape: "square"
                },
                legend: {
                    show: true,
                    align: "right",
                    minLabel: "Less",
                    maxLabel: "More",
                    divider: " to "
                },
                tooltips: {
                    show: false,
                    options: {}
                }
            };

        // The actual plugin constructor
        function Plugin( element, data, options ) {
            this.element = element;
            this.data = data;
            this.settings = $.extend( true, {}, defaults, options );
            this._defaults = defaults;
            this._name = pluginName;
            this.init();
        }

        // Avoid Plugin.prototype conflicts
        $.extend( Plugin.prototype, {
            init: function() {

                // Run Calandar Heatmap Function
                this.calendarHeatmap();

                // Check if the moment.js library is available.
                if ( !moment ) {
                    console.log( "The calendar heatmap plugin requires moment.js" );
                }
            },
            _parse: function( dates ) {
                var arr = [];
                if ( !Array.isArray( dates ) || typeof dates !== "object" ) {
                    console.log( "Invalid data source" );
                    return null;
                } else {
                    if ( Array.isArray( dates ) && dates.length > 0 ) {
                        var arrtype = typeof dates[ 0 ];
                        if ( typeof dates[ 0 ] === "object" && !Array.isArray( dates[ 0 ] ) ) {
                            if ( dates[ 0 ].date && dates[ 0 ].count ) {
                                arr = [];
                                for ( var h in dates ) {
                                    var objDate = dates[ h ].date;
                                    if ( $.isNumeric( dates[ h ].date ) ) {
                                        objDate = parseInt( dates[ h ].date );
                                    }
                                    arr.push( {
                                        "count": parseInt( dates[ h ].count ),
                                        "date": moment( objDate ).format( "YYYY-MM-DD" )
                                    } );
                                }
                                return arr;
                            } else {
                                    console.log( "Invalid Object format." );
                                return null;
                            }
                        } else if ( [ "string", "date", "number" ].indexOf( arrtype ) > -1 ) {
                            if ( moment( dates[ 0 ] ).isValid() ) {
                                var obj = {};
                                for ( var i in dates ) {
                                    var d = moment( dates[ i ] ).format( "YYYY-MM-DD" );
                                    if ( !obj[ d ] ) {
                                        obj[ d ] = 1;
                                    } else {
                                        obj[ d ] += 1;
                                    }
                                }
                                arr = [];
                                for ( var j in obj ) {
                                    arr.push( {
                                        "count": parseInt( obj[ j ] ),
                                        "date": j
                                    } );
                                }
                                return arr;
                            } else {
                                console.log( "Invalid Date format." );
                                return null;
                            }
                        } else {
                            console.log( "Invalid format." );
                            return null;
                        }
                    } else if ( Array.isArray( dates ) && dates.length === 0 ) {
                        return [];
                    } else if ( typeof dates === "object" && !Object.empty( dates ) ) {
                        var keys = Object.keys( dates );
                        if ( moment( keys[ 0 ] ).isValid() ) {
                            if ( this._isNumeric( dates[ keys[ 0 ] ] ) ) {
                                var data = [];
                                for ( var k in dates ) {
                                    data.push( {
                                        "count": parseInt( dates[ k ] ),
                                        "date": moment( k ).format( "YYYY-MM-DD" )
                                    } );
                                }
                                return data;
                            }
                        } else {
                            console.log( "Invalid Date format." );
                            return null;
                        }
                    } else {
                        return null;
                    }
                }
            },
            _pad: function( str, max ) {
                str = String( str );
                return str.length < max ? this._pad( "0" + str, max ) : str;
            },
            _calculateBins: function( events ) {

                // Calculate bins for events
                var i;
                var bins = this.settings.steps || 4;
                var binlabels = [ "0" ];
                var binlabelrange = [ [ 0, 0 ] ];

                // Create an array with all counts
                var arr = events.map( function( x ) {
                    return parseInt( x.count );
                } );

                var minCount = Math.min.apply( Math, arr );
                var maxCount = Math.max.apply( Math, arr );
                var stepWidth = Math.ceil( ( maxCount - minCount ) / bins );

                if ( stepWidth === 0 ) {
                    stepWidth = maxCount / bins;
                    if ( stepWidth < 1 ) {
                        stepWidth = 1;
                    }
                }

                // Generate bin lables and ranges
                binlabelrange = [ [ 0, 0 ] ];
                if ( !Number.isFinite( minCount ) ) {
                    binlabels = [ "" ];
                } else {
                    binlabels = [ "0" ];
                }

                for ( i = 0; i < bins; i++ ) {

                    var r1 = ( stepWidth * i ) + 1;
                    var r2 = stepWidth * ( i + 1 );

                    binlabelrange.push( [ r1, r2 ] );

                    if ( !Number.isFinite( minCount ) ) {
                        binlabels.push( "" );
                    } else if ( Number.isNaN( r1 ) || !Number.isFinite( r1 ) ) {
                        binlabels.push( "" );
                    } else if ( r1 === r2 ) {
                        binlabels.push( String( r1 ) );
                    } else {
                        binlabels.push( String( r1 ) +
                            ( this.settings.legend.divider || " to " ) +
                            String( r2 ) );
                    }
                }

                // Assign levels (bins) to counts
                for ( i in events ) {
                    events[ i ].level = this._matchBin( binlabelrange, events[ i ].count );
                }

                return { events: events, bins: binlabels };
            },
            _matchBin: function( range, value ) {
                for ( var r in range ) {
                    if ( value >= range[ r ][ 0 ] && value <= range[ r ][ 1 ] ) {
                        return parseInt( r );
                    }
                }
                return 0;
            },
            _matchDate: function( obj, key ) {
                return obj.find( function( x ) {
                    return x.date === key;
                } ) || null;
            },
            _matchDateIdx: function( obj, key ) {
                return obj.findIndex( function( x ) {
                    return x.date === key;
                } );
            },
            _futureDate: function( str ) {
                return moment( str ).diff( moment(), "days" ) >= 0 &&
                moment( str ).format( "YYYY-MM-DD" ) !== moment().format( "YYYY-MM-DD" ) ?
                true : false;
            },
            _isNumeric: function( n ) {
                return !isNaN( parseFloat( n ) ) && isFinite( n );
            },
            _addWeekColumn: function( ) {
                if ( this.settings.labels.days ) {
                    $( ".ch-year", this.element )
                        .append( "<div class=\"ch-week-labels\"></div>" );

                    $( ".ch-week-labels", this.element )
                        .append( "<div class=\"ch-week-label-col\"></div>" );

                    $( ".ch-week-label-col", this.element )
                        .append( "<div class=\"ch-day-labels\"></div>" );

                    // If month labels are displayed a placeholder needs to be added
                    if ( this.settings.labels.months ) {
                        $( ".ch-week-labels", this.element )
                            .append( "<div class=\"ch-month-label\">&nbsp;</div>" );
                    }

                    var swd = this.settings.weekStartDay;

                    for ( var i = 0; i < 7; i++ ) {

                        var dayName = moment().weekday( ( i + swd ) ).format( "ddd" );
                        var dayNumber = moment().weekday( ( i + swd ) ).format( "d" );
                        if ( ( i - 1 ) % 2 ) {
                            var wdl = this.settings.labels.custom.weekDayLabels;
                            if ( Array.isArray( wdl ) ) {
                                dayName = wdl[ dayNumber ] || "";
                            } else if ( typeof wdl === "string" ) {
                                dayName = moment().weekday( ( i + swd ) )
                                .format( wdl );
                            }
                        } else {
                            dayName = "&nbsp;";
                        }
                        $( "<div>", {
                            class: "ch-day-label",
                            html: dayName
                        } )
                        .appendTo( $( ".ch-day-labels", this.element ) );
                    }
                }
            },
            calendarHeatmap: function( ) {

                var data = this._parse( this.data );

                if ( !Array.isArray( data ) ) {
                    return;
                }

                this.data = data;
                var calc = this._calculateBins( data );
                var events = calc.events;
                var binLabels = calc.bins;
                var currMonth = this.settings.lastMonth;
                var currYear = this.settings.lastYear;
                var months = this.settings.months;
                var i;

                // Start day of the week
                var swd = this.settings.weekStartDay || 1;

                // Empty container first
                $( this.element ).empty();

                // Add a title to the container if not null
                if ( this.settings.title ) {
                    $( "<h3>", {
                        class: "ch-title",
                        html: this.settings.title
                    } ).appendTo( $( this.element ) );
                }

                // Add the main container for the year
                $( this.element ).addClass( "ch" )
                    .append( "<div class=\"ch-year\"></div>" );

                // Add labels
                this._addWeekColumn();

                // Adjust tile shape
                if ( this.settings.tiles.shape && this.settings.tiles.shape !== "square" ) {
                    $( this.element ).addClass( " ch-" + this.settings.tiles.shape );
                }

                // Start building the months
                for ( i = months; i > 0; i-- ) {

                    var month = currMonth - i;
                    var year = currYear;
                    if ( month < 0 ) {
                        year -= 1;
                        month += 12; // TODO: FIX for more than one year
                    }

                    // Build Month
                    var monthName = moment().set( { "month": month, "year": year } )
                    .format( "MMM" );
                    if ( this.settings.labels.custom.monthLabels ) {
                        if ( Array.isArray( this.settings.labels.custom.monthLabels ) ) {
                            monthName = this.settings.labels.custom.monthLabels[ month ] || "";
                        } else {
                            monthName = moment().set( { "month": month, "year": year } )
                                .format( this.settings.labels.custom.monthLabels );
                        }
                    }
                    $( ".ch-year", this.element )
                        .append( "<div class=\"ch-month\"></div>" );

                    $( ".ch-month:last", this.element )
                        .append( "<div class=\"ch-weeks\"></div>" );

                    if ( this.settings.labels.months ) {
                        $( ".ch-month:last", this.element )
                        .append( "<div class=\"ch-month-label\">" + monthName + "</div>" );
                    }

                    // Get the number of days for the month
                    var days = moment().set( { "month": month, "year": year } ).daysInMonth();

                    // Add the first week
                    $( ".ch-month:last .ch-weeks", this.element )
                        .append( "<div class=\"ch-week\"></div>" );

                    // Week day counter
                    var wc = 0;
                    for ( var j = 0; j < days; j++ ) {
                        var str = year + "-" + this._pad( ( month + 1 ), 2 );
                        str += "-" + this._pad( ( j + 1 ), 2 );
                        var obj = this._matchDate( events, str );
                        var future = "";
                        if ( this._futureDate( str ) ) {
                            future = " is-after-today";
                        }
                        if ( obj ) {
                            var title = obj.count + " on ";
                            title += moment( obj.date ).format( "ll" );

                            var color = "";

                            if ( this.settings.coloring ) {
                                color = " " + this.settings.coloring + "-" + obj.level;
                            }

                            $( "<div/>", {
                                "class": "ch-day lvl-" + obj.level + color,
                                "title": title,
                                "data-toggle": "tooltip"
                            } ).appendTo(
                                $( ".ch-month:last .ch-weeks .ch-week:last", this.element )
                            );

                        } else {
                            $( "<div/>", {
                                "class": "ch-day" + future
                            } ).appendTo(
                                $( ".ch-month:last .ch-weeks .ch-week:last", this.element )
                            );
                        }

                        // Get the iso week day to see if a new week has started
                        var wd = moment().set( {
                            "date": ( j + 2 ),
                            "month": month,
                            "year": year
                        } ).isoWeekday();

                        // Incrementing the day counter for the week
                        wc++;

                        if ( wd === swd  && ( days - 1 ) > j ) {

                            $( ".ch-month:last .ch-weeks", this.element )
                                .append( "<div class=\"ch-week\">" + j + "</div>" );

                            // Reset the week day counter
                            wc = 0;
                        }
                    }

                    // Now fill up the last week with blank days
                    for ( wc; wc < 7; wc++ ) {
                        $( ".ch-month:last .ch-weeks .ch-week:last", this.element )
                            .append( "<div class=\"ch-day is-outside-month\"></div>" );
                    }
                }

                // Add a legend
                if ( this.settings.legend.show ) {

                    // Add the legend container
                    $( "<div>", {
                        class: "ch-legend"
                    } )
                    .appendTo( this.element )
                    .append( "<small>" + ( this.settings.legend.minLabel || "" ) + "</small>" )
                    .append( "<ul class=\"ch-lvls\"></ul>" )
                    .append( "<small>" + ( this.settings.legend.maxLabel || "" ) + "</small>" );

                    if ( this.settings.legend.align === "left" ) {
                        $( ".ch-legend", this.element ).addClass( "ch-legend-left" );
                    }

                    if ( this.settings.legend.align === "center" ) {
                        $( ".ch-legend", this.element ).addClass( "ch-legend-center" );
                    }

                    // Add the legend steps
                    for ( i = 0; i < binLabels.length; i++ ) {
                        $( "<li>", {
                            "class": "ch-lvl lvl-" + i,
                            "title": binLabels[ i ],
                            "data-toggle": "tooltip"
                        } )
                        .appendTo( $( ".ch-lvls", this.element ) );
                        if ( this.settings.coloring ) {
                            $( ".ch-lvls li:last", this.element  )
                            .addClass( this.settings.coloring + "-" + i );
                        }
                    }
                }

                // Add tooltips to days and steps
                if ( this.settings.tooltips.show && typeof $.fn.tooltip === "function" ) {
                    $( "[data-toggle=\"tooltip\"]", this.element )
                    .tooltip( this.settings.tooltips.options );
                }
            },
            updateDates: function( arr ) {
                this.data = arr;
                this.calendarHeatmap();
            },
            appendDates: function( arr ) {
                var toAppend =  this._parse( arr );
                if ( Array.isArray( toAppend ) && Array.isArray( this.data ) ) {
                    for ( var i in toAppend ) {
                        var  idx = this._matchDateIdx( this.data, toAppend[ i ].date );
                        if ( idx > -1 ) {
                            this.data[ idx ].count += toAppend[ i ].count;
                        } else {
                            this.data.push( toAppend[ i ] );
                        }
                    }
                }
                this.calendarHeatmap();
            },
            updateOptions: function( obj ) {
                this.settings = $.extend( true, {}, this.settings, obj );
                this.calendarHeatmap();
            },
            getDates: function( ) {
                return this.data;
            },
            getOptions: function( ) {
                return this.settings;
            }
        } );

        // A really lightweight plugin wrapper around the constructor,
        // preventing against multiple instantiations
        $.fn[ pluginName ] = function( data, options ) {
            var args = arguments;

            // Is the first parameter an object (options), or was omitted,
            // instantiate a new instance of the plugin.
            // if ( data === undefined || typeof data === "object" ) {
            if ( Array.isArray( data ) ) {
                return this.each( function() {

                    // Only allow the plugin to be instantiated once,
                    // so we check that the element has no plugin instantiation yet
                    if ( !$.data( this, "plugin_" + pluginName ) ) {

                        // if it has no instance, create a new one,
                        // pass options to our plugin constructor,
                        // and store the plugin instance
                        // in the elements jQuery data object.
                        $.data( this, "plugin_" + pluginName, new Plugin( this, data, options ) );
                    }
                } );

            // If the first parameter is a string and it doesn't start
            // with an underscore or "contains" the `init`-function,
            // treat this as a call to a public method.
            } else if ( typeof data === "string" && data[ 0 ] !== "_" && data !== "init" ) {

                // Cache the method call
                // to make it possible
                // to return a value
                var returns;

                this.each( function() {
                    var instance = $.data( this, "plugin_" + pluginName );

                    // Tests that there's already a plugin-instance
                    // and checks that the requested public method exists
                    if ( instance instanceof Plugin && typeof instance[ data ] === "function" ) {

                        // Call the method of our plugin instance,
                        // and pass it the supplied arguments.
                        returns = instance[ data ].apply( instance,
                            Array.prototype.slice.call( args, 1 ) );
                    }

                    // Allow instances to be destroyed via the 'destroy' method
                    if ( data === "destroy" ) {
                        $( this ).removeData();
                    }
                } );

                // If the earlier cached method
                // gives a value back return the value,
                // otherwise return this to preserve chainability.
                return returns !== undefined ? returns : this;
            }
        };

} )( jQuery );
/* global moment   calendar calmosaic 3 */
(function ($) {
    "use strict";

    // Default Options
    var pluginName = "calmosaic",
        defaults = {
            title: null,
            months: 12,
            lastMonth: moment().month() + 1,
            lastYear: moment().year(),
            coloring: null,
            labels: {
                days: false,
                months: true,
                custom: {
                    weekDayLabels: null,
                    monthLabels: null
                }
            },
            legend: {
                show: true,
                align: "right",
                minLabel: "Less",
                maxLabel: "More"
            }
        };

    // The actual plugin constructor
    function Plugin(element, data, options) {
        this.element = element;
        this.data = data;
        this.settings = $.extend(true, {}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            // Run Calandar Heatmap Function
            this.calendarHeatmap();

            // Check if the moment.js library is available.
            if (!moment) {
                console.log("The calmosaic plugin requires moment.js");
            }
        },
        parse: function () {
            var type = $.type(this.data);
            if (["array", "object"].indexOf(type) === -1) {
                console.log("Invalid data source");
                return null;
            } else {
                if (type === "array" && this.data.length > 0) {
                    var arrtype = $.type(this.data[0]);
                    if (arrtype === "object") {
                        if (this.data[0].date && this.data[0].count) {
                            return this.data.slice(0);
                        } else {
                            return null;
                        }
                    } else if (["string", "date"].indexOf(arrtype) > -1) {
                        if (moment(this.data[0]).isValid()) {
                            var obj = {};
                            for (var i in this.data) {
                                var d = moment(this.data[i]).format("YYYY-MM-DD");
                                if (!obj[d]) {
                                    obj[d] = 1;
                                } else {
                                    obj[d] += 1;
                                }
                            }
                            var arr = [];
                            for (var j in obj) {
                                arr.push({
                                    "count": obj[j],
                                    "date": j
                                });
                            }
                            return arr;
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                } else if (type === "array" && this.data.length === 0) {
                    return [];
                } else if (type === "object" && !Object.empty(this.data)) {
                    var keys = Object.keys(this.data);
                    if (moment(keys[0]).isValid()) {
                        if ($.type(this.data[keys[0]]) === "number") {
                            var data = [];
                            for (var k in this.data) {
                                data.push({
                                    "count": this.data[k],
                                    "date": moment(k).format("YYYY-MM-DD")
                                });
                            }
                            return data;
                        }
                    } else {
                        return null;
                    }
                } else {
                    return null;
                }
            }
        },
        index: function (data) {
            this.idx = {};
            for (var i in data) {
                this.idx[data[i].date] = i;
            }
        },
        pad: function (str, max) {
            str = String(str);
            return str.length < max ? this.pad("0" + str, max) : str;
        },
        calculateBins: function (events) {
            // Calculate bins for events
            var arr = [];
            var i;
            var bins = this.settings.steps || 4;
            var binlabels = ["0"];
            var binlabelrange = [
                [0, 0]
            ];
            for (i in events) {
                events[i].count = parseInt(events[i].count);
                arr.push(events[i].count);
            }
            var firstStep = Math.min.apply(Math, arr);
            var maxCount = Math.max.apply(Math, arr);
            var stepWidth = (maxCount - firstStep) / bins;

            if (stepWidth === 0) {
                stepWidth = maxCount / bins;
                if (stepWidth < 1) {
                    stepWidth = 1;
                }
            }

            // Generate bin labels
            for (i = 0; i < bins; i++) {
                if (!isFinite(firstStep)) {
                    binlabels.push("");
                    binlabelrange.push([null, null]);
                } else if (maxCount < bins) {
                    if ((i - (bins - maxCount)) >= 0) {
                        binlabels.push(String(1 + (i - (bins - maxCount))));
                        binlabelrange.push([
                            (1 + (i - (bins - maxCount))),
                            (1 + (i - (bins - maxCount)))
                        ]);
                    } else {
                        binlabels.push("");
                        binlabelrange.push([null, null]);
                    }
                } else if (maxCount === bins) {
                    binlabels.push(String((i + 1)));
                    binlabelrange.push([(i + 1), (i + 1)]);
                } else if ((maxCount - 2) === bins) {
                    if ((i + 1) === bins) {
                        binlabels.push(String((i + 1)) + "+");
                        binlabelrange.push([(i + 1), null]);
                    } else {
                        binlabels.push(String((i + 1)));
                        binlabelrange.push([(i + 1), (i + 1)]);
                    }
                } else {
                    var l = Math.round(i * stepWidth) + 1;
                    var ll = Math.round(i * stepWidth + stepWidth);
                    binlabelrange.push([l, ll]);
                    if (i === (bins - 1)) {
                        l += "+";
                    } else {
                        if (l !== ll) {
                            l += " to ";
                            l += ll;
                        }
                    }
                    binlabels.push(String(l));
                }
            }

            // Assign bins to counts
            for (i in events) {
                if (events[i].count === 0) {
                    events[i].level = 0;
                } else if (events[i].count - firstStep === 0) {
                    events[i].level = 1;
                } else if (!isFinite(firstStep)) {
                    events[i].level = bins;
                } else {
                    events[i].level = this.matchBin(binlabelrange, events[i].count);
                }
            }

            return {
                events: events,
                bins: binlabels
            };
        },
        matchBin: function (range, value) {
            for (var r in range) {
                if (value >= range[r][0] && value <= range[r][1]) {
                    return r;
                }
            }
            return 0;
        },
        matchDate: function (obj, key) {
            if (this.idx[key]) {
                return obj[this.idx[key]];
            } else {
                return null;
            }
        },
        calendarHeatmap: function () {
            var data = this.parse();

            if ($.type(data) !== "array") {
                return;
            }

            // Generate lookup index
            this.index(data);

            var calc = this.calculateBins(data);
            var events = calc.events;
            var binLabels = calc.bins;
            var currMonth = this.settings.lastMonth;
            var currYear = this.settings.lastYear;
            var months = this.settings.months;
            var i;

            // Empty container first
            $(this.element).empty();

            // Add a title to the container if not null
            if (this.settings.title) {
                $("<h3>", {
                    class: "ch-title",
                    html: this.settings.title
                }).appendTo($(this.element));
            }

            var $graph = $("<div class='ch-graph' />");
            var $months = $("<ul class='ch-months' />");
            var $days = $("<ul class='ch-days'></ul>");

            $graph.append($months);
            $graph.append($days);

            $(this.element).append($graph);

            // Start building the months
            for (i = months; i > 0; i--) {
                var month = currMonth - i;
                var year = currYear;
                if (month < 0) {
                    year -= 1;
                    month += 12; // TODO: FIX for more than one year
                }

                // Build Month
                var monthName = moment().set({
                        "month": month,
                        "year": year
                    })
                    .format("MMM");
                if (this.settings.labels.custom.monthLabels) {
                    if ($.type(this.settings.labels.custom.monthLabels) === "array") {
                        monthName = this.settings.labels.custom.monthLabels[month] || "";
                    } else {
                        monthName = moment().set({
                                "month": month,
                                "year": year
                            })
                            .format(this.settings.labels.custom.monthLabels);
                    }
                }

                $months.append("<li>" + monthName + "</li>");

                // Get the number of days for the month
                var days = moment().set({
                    "month": month,
                    "year": year
                }).daysInMonth();

                // Build days
                for (var j = 0; j < days; j++) {
                    var str = year + "-" + this.pad((month + 1), 2);
                    str += "-" + this.pad((j + 1), 2);
                    var obj = this.matchDate(events, str);

                    if (obj) {
                        var title = obj.count + " on ";
                        title += moment(obj.date).format("ll");

                        var color = "";

                        if (this.settings.coloring) {
                            color = " " + this.settings.coloring + "-" + obj.level;
                        }

                        $("<li/>", {
                            "class": "ch-day lvl-" + obj.level + color,
                            "title": title
                        }).appendTo(
                            $days
                        );
                    } else {
                        $("<li/>", {
                            "class": "ch-day",
                            "title": str
                        }).appendTo(
                            $days
                        );
                    }
                }
            }

            // Add a legend
            if (this.settings.legend.show) {
                // Add the legend container
                $("<div>", {
                        class: "ch-legend"
                    })
                    .appendTo($graph)
                    .append("<small>" + (this.settings.legend.minLabel || "") + "</small>")
                    .append("<ul class=\"ch-lvls\"></ul>")
                    .append("<small>" + (this.settings.legend.maxLabel || "") + "</small>");

                if (this.settings.legend.align === "left") {
                    $(".ch-legend", this.element).addClass("ch-legend-left");
                }

                if (this.settings.legend.align === "center") {
                    $(".ch-legend", this.element).addClass("ch-legend-center");
                }

                // Add the legend steps
                for (i = 0; i < binLabels.length; i++) {
                    $("<li>", {
                            "class": "ch-lvl lvl-" + i,
                            "title": binLabels[i],
                            "data-toggle": "tooltip"
                        })
                        .appendTo($(".ch-lvls", this.element));
                    if (this.settings.coloring) {
                        $(".ch-lvls li:last", this.element)
                            .addClass(this.settings.coloring + "-" + i);
                    }
                }
            }
        }
    });

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function (data, options) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" +
                    pluginName, new Plugin(this, data, options));
            }
        });
    };
})(jQuery);

vm.config_calmosaic = {             
    // heatmap title
    title: null,
    // the number of months
    months: 12,

    // last month
    lastMonth: moment().month() + 1,
   
    // last year
    lastYear: moment().year(),
    // gradients
    // 'Earth', 'Electric', 'Viridis'
    // 'Picknick', 'Green'
    // 'Blue', 'Red', 'Teal'
    coloring: 'Orange',
   
    // lables options
    labels: {
      days: true,
      months: true,
      custom: {
        weekDayLabels: null,
        monthLabels: null
      }
    },
   
    // legend options
    legend: {
      show: true,
      align: "right",
      minLabel: "Less",
      maxLabel: "More"
    }

  };

    WS.getData('heatmap/sumNetapayer', {type: 'bl'})
      .then(function (response) {
        $(function(){
           // $("#calendar-heatmap-vente").CalendarHeatmap(response.data, {});
            $("#calendar-heatmap-vente").calmosaic(response.data, vm.config_calmosaic);
        });

      });

// const data = [
//     {
//       count: 2,
//       date: "2020-09-23"
//     },{
//       count: 5,
//       date: "2020-10-23"
//     }
//     ,{
//       count: 59000,
//       date: "2021-01-01"
//     }
// ];
// $(function(){
//     $("#calendar-heatmap-commande").CalendarHeatmap(data, {});
// });
/****************************************************************33333**************************************************************** */



	// const myData = [
	//       {
	//         count: 2,
	//         date: "2020-09-23"
	//       },{
	//         count: 5,
	//         date: "2020-10-23"
    //       }
    //       ,{
	//         count: 59000,
	//         date: "2021-01-01"
	//       }
    // ];
    
	// $(function(){
	//   $("#calendar-heatmap-vente").calmosaic(myData, {             
    //           // heatmap title
    //           title: null,
    //           // the number of months
    //           months: 12,

    //           // last month
    //           lastMonth: moment().month() + 1,
             
    //           // last year
    //           lastYear: moment().year(),
    //           // gradients
    //           // 'Earth', 'Electric', 'Viridis'
    //           // 'Picknick', 'Green'
    //           // 'Blue', 'Red', 'Teal'
    //           coloring: 'Orange',
             
    //           // lables options
    //           labels: {
    //             days: false,
    //             months: true,
    //             custom: {
    //               weekDayLabels: null,
    //               monthLabels: null
    //             }
    //           },
             
    //           // legend options
    //           legend: {
    //             show: true,
    //             align: "right",
    //             minLabel: "Less",
    //             maxLabel: "More"
    //           }

    //         });
    // });
    
    
    WS.getData('heatmap/sumNetapayer', {type: 'commande'})
      .then(function (response) {
        $(function(){
            
            //$("#calendar-heatmap-commande").CalendarHeatmap(response.data, {});
            $("#calendar-heatmap-commande").calmosaic(response.data, vm.config_calmosaic);
        });

      });
}
export default {
    name: 'heatmapController',
    fn: heatmapController
};